// Short badge labels for Business Central document types — "BC PO" / "BC PI"
// instead of the full "Purchase Order" / "Purchase Invoice" display name, for
// use anywhere space is tight (list badges, request page headers).
//
// Keyed by bc_entity_type_key so a new entity type just needs an entry here;
// an unrecognised key still renders something reasonable rather than nothing.
const BC_ENTITY_SHORT_LABELS = {
  purchase_order: 'BC PO',
  purchase_invoice: 'BC PI',
  completion_statement: 'BC CS',
}

/**
 * @param {string} entityTypeKey - e.g. 'purchase_order', 'purchase_invoice'
 * @param {string} [displayName] - full display name as a fallback source, e.g. 'Purchase Order'
 * @returns {string} short badge text, e.g. 'BC PO'
 */
export function bcEntityShortLabel(entityTypeKey, displayName) {
  if (entityTypeKey && BC_ENTITY_SHORT_LABELS[entityTypeKey]) {
    return BC_ENTITY_SHORT_LABELS[entityTypeKey]
  }
  if (displayName) {
    // Derive an abbreviation from the display name's initials, e.g.
    // 'Sales Credit Memo' -> 'BC SCM', so a new entity type gets a sensible
    // badge before anyone remembers to add it to the map above.
    const initials = displayName
      .split(/\s+/)
      .map(w => w[0])
      .join('')
      .toUpperCase()
      .slice(0, 4)
    return initials ? `BC ${initials}` : 'BC Document'
  }
  return 'BC Document'
}
